import Choices from 'choices.js';

export default class ChoicesSelect {
  textDefaultOptions = {
    itemSelectText: '',
    loadingText: 'Chargement...',
    noResultsText: 'Aucun résultat',
    noChoicesText: 'Aucun choix disponible',
    uniqueItemText: 'Valeurs uniques seulement',
    customAddItemText:
      'Les valeurs saisies doivent respecter certaines conditions.',
    addItemText: (value) => {
      return `Appuyer sur Entrer pour ajouter <b>"${value}"</b>`;
    },
    maxItemText: (maxItemCount) => {
      return `Seulement ${maxItemCount} ${
        maxItemCount > 1
          ? 'valeurs peuvent être ajoutées'
          : 'valeur peut être ajoutée'
      }`;
    },
  };

  multipleDefaultOptions = {
    searchEnabled: true,
    paste: false,
    shouldSort: false,
    renderSelectedChoices: 'always',
  };

  simpleDefaultOptions = {
    searchEnabled: false,
    shouldSort: false,
    renderSelectedChoices: 'always',
  };

  constructor(element, options = {}) {
    this.choicesObject = undefined;
    this.element = element;
    this.options = options;

    if (!this.element) {
      return;
    }

    this.init();
  }

  init() {
    const isMultiple =
      this.element.getAttribute('multiple') === 'true' || this.options.multiple;

    let choicesOptions = {
      ...this.textDefaultOptions,
      /* eslint-disable-next-line object-shorthand */
      callbackOnInit: function () {
        ChoicesSelect.checkPlaceholderState(
          this.passedElement.element.value,
          this
        );

        const inputClonedElement = this.containerOuter.element.querySelector(
          '.choices__input--cloned'
        );

        if (inputClonedElement && inputClonedElement.style.minWidth) {
          inputClonedElement.style.setProperty(
            '--initial-min-width',
            inputClonedElement.style.minWidth
          );
        }

        ChoicesSelect.appendItemCounter(
          this.getValue(true).length,
          this.containerOuter.element.querySelector('.choices__list--multiple')
        );
      },
    };

    if (isMultiple) {
      choicesOptions = {
        ...choicesOptions,
        ...this.multipleDefaultOptions,
      };
    } else {
      choicesOptions = {
        ...choicesOptions,
        ...this.simpleDefaultOptions,
      };
    }

    const newChoiceElement = new Choices(this.element, {
      ...choicesOptions,
      ...this.options,
    });

    if (isMultiple) {
      newChoiceElement.passedElement.element.addEventListener(
        'change',
        (event) => {
          ChoicesSelect.checkPlaceholderState(
            event.target.value,
            newChoiceElement
          );

          ChoicesSelect.appendItemCounter(
            newChoiceElement.getValue(true).length,
            newChoiceElement.containerOuter.element.querySelector(
              '.choices__list--multiple'
            )
          );
        },
        false
      );

      newChoiceElement.passedElement.element.addEventListener(
        'choice',
        (event) => {
          newChoiceElement.getValue(true).forEach((item) => {
            if (item !== event.detail.choice.value) return;

            setTimeout(() => {
              newChoiceElement.removeActiveItemsByValue(
                event.detail.choice.value
              );

              ChoicesSelect.checkPlaceholderState(
                newChoiceElement.getValue(true).join(' '),
                newChoiceElement
              );
            }, 100);
          });
        }
      );
    }

    this.choicesObject = newChoiceElement;
  }

  static checkPlaceholderState(value, choicesObject) {
    if (
      (!value || value === '') &&
      choicesObject.passedElement.element.dataset.placeholder
    ) {
      choicesObject.input.element.classList.add('with-placeholder');
      choicesObject.input.element.classList.remove('without-placeholder');
    } else {
      choicesObject.input.element.classList.remove('with-placeholder');
      choicesObject.input.element.classList.add('without-placeholder');
    }
  }

  static appendItemCounter(value, parentNode, maxItems = 2) {
    value = parseInt(value);

    if (!parentNode) {
      return;
    }

    if (value < maxItems + 1) {
      return;
    }

    const itemCounter = document.createElement('div');

    itemCounter.classList.add('choices__item-counter');
    itemCounter.innerText = `+${value - maxItems}`;

    parentNode.appendChild(itemCounter);
  }
}
